import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class RequestUtils {

    public static promisifyRequest(options: any, httpClient: HttpClient): Observable<any> {
            switch (options.method) {
                case 'GET':
                    return httpClient.get(options.url, { headers: options.headers });
                case 'POST':
                    return httpClient.post(options.url, options.body, { headers: options.headers });
                case 'PUT':
                    return httpClient.put(options.url, options.body, { headers: options.headers });
                case 'PATCH':
                    return httpClient.patch(options.url, options.body, { headers: options.headers });
                case 'DELETE':
                    return httpClient.delete(options.url, { headers: options.headers });
                default:
                    return null;
            }

    }

}
